import { Component } from "../component"
import { iterable } from "../helpers/iterable"

export class Tabs extends Component {
  constructor(props) {
    super(props)

    this.dynamicClasses = {
      active: "-active",
    }
  }

  ui() {
    return {
      tabs: ".tabs",
      links: ".tabs-link",
      contentItems: ".tabs-content-item",
    }
  }

  attachEvents() {
    const { tabs, links, contentItems } = this.$ui
    const { active } = this.dynamicClasses

    iterable(links).forEach((link, index) => {
      link.addEventListener("click", (e) => {
        const currentActive = tabs.querySelector(`.${active}`)
        currentActive.classList.remove(active)
        link.parentElement.classList.add(active)

        iterable(contentItems).forEach((item, itemIndex) => {
          item.classList.toggle(active, itemIndex === index)
        })
        e.preventDefault()
      })
    })
  }

  created() {
    this.attachEvents()
  }
}
